import { useMutation } from 'react-query';
import { UserAPI } from 'api/user';
import dispatchToast from 'helpers/dispatchToast';

export default function useAdminUpdatePassword() {
  return useMutation(
    UserAPI.adminUpdatePassword,
    {
      onSuccess: ({ message }) => {
        dispatchToast({ message, type: 'success' })
      },
    }
  );
}
